import moment from 'moment';
import { createDeepEqualSelector } from './';
import { SearchGlobalStateType } from '../../types';

export const projectsSelector = (state: SearchGlobalStateType) =>
  state.projects;

moment().utc().format('YYYY-MM-DD HH:mm:ss');

export const isProjectModalOpenSelector = createDeepEqualSelector(
  projectsSelector,
  (projects) => projects.isProjectModalOpen,
);

export const projectModalEventLocationSelector = createDeepEqualSelector(
  projectsSelector,
  (projects) => projects.projectModalEventLocation,
);
